export default "__VITE_ASSET__DsPKw6vc__"